<script>
import axios from 'axios'
import DisplayExecutionSchema from '@/components/execution/DisplayExecutionSchema.vue'

export default {
  name: 'ExecutionWorkflowDetails',
  components: {
    DisplayExecutionSchema
  },
  props: {
    execution: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      globalStack: null
    }
  },
  mounted() {
    this.getGlobalStack()
  },
  methods: {
    getGlobalStack() {
      axios
        .get(`/api/v1/stacks/${this.execution.stackId}`)
        .then(response => {
          this.globalStack = response.data
        })
        .catch(error => {
          console.log(error)
          this.globalStack = null
        })
    }
  }
}
</script>

<template>
  <v-card :class="$vuetify.dark ? 'card-dark ' : 'card-light '">
    <v-flex class="pt-3">
      <v-layout class="row wrap px-1">
        <v-flex xs12 sm6 md3 class="pa-1">
          <v-label>
            <span class="body-1 beez-bold">Execution ID: </span>
            <br />
            <span class="body-2 beez-grey--text">{{ execution.hexId }}</span>
          </v-label>
        </v-flex>
        <v-flex xs12 sm6 md3 class="pa-1">
          <v-label>
            <span class="body-1 beez-bold"> External ID: </span>
            <br />
            <span class="body-2 beez-grey--text">{{
              execution.externalId
            }}</span>
          </v-label>
        </v-flex>
        <v-flex xs12 sm6 md3 class="pa-1">
          <v-label>
            <span class="body-1 beez-bold"> State ID: </span>
            <br />
            <span class="body-2 beez-grey--text">{{ execution.state }}</span>
          </v-label>
        </v-flex>
        <v-flex xs12 sm6 md3 class="pa-1">
          <v-label>
            <span class="body-1 beez-bold"> Global Stack ID: </span>
            <br />
            <span class="body-2 beez-grey--text">{{ execution.stackId }}</span>
          </v-label>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex class="pt-3">
      <display-execution-schema
        v-if="globalStack"
        :input="globalStack.variables"
      />
    </v-flex>
  </v-card>
</template>

<style scoped></style>
